import React from 'react'
import Setting from '../Layout/Infomation/setting'

const SettingPage = () => {
  return <Setting />
}

export default SettingPage
